import React, { useEffect } from "react"
import {
  Modal,
  Form,
  InputNumber,
  DatePicker,
  Select,
  Upload,
  Button,
  Input,
} from "antd"
import dayjs from "dayjs"
import toastr from "toastr"
import * as moment from "moment"
import * as Http from "utils/http.helper"
import { UploadOutlined } from "@ant-design/icons"

const { TextArea } = Input
const { Option } = Select

const paymentMethods = [
  { value: 10, label: "BankTransfer" },
  { value: 20, label: "CreditCard" },
  { value: 30, label: "DebitCard" },
  { value: 40, label: "Cash" },
  { value: 50, label: "Check" },
  { value: 60, label: "MobilePayment" },
  { value: 70, label: "OnlinePayment" },
  { value: 80, label: "Cryptocurrency" },
]

export default function UpsertModal({ visible, data, onClose, onUpdated }) {
  const [form] = Form.useForm()
  const [submitting, setSubmitting] = React.useState(false)

  const roleId = JSON.parse(localStorage.getItem("authUserV0"))?.roleId
  const isReadonly = roleId === 2

  useEffect(() => {
    if (visible && data) {
      form.setFieldsValue({
        id: data.id,
        paidAmount: data.paymentAmount,
        paymentMethod: data.paymentMethod,
        deadLineDate: data.deadlineDate ? dayjs(data.deadlineDate) : null,
        paymentDate: data.paymentDate ? dayjs(data.paymentDate) : null,
        status: data.status,
        description: data.description,
        receipt: data.receiptUrl ? [{ name: "Yüklü Dekont", status: "done" }] : [],
      })
    } else {
      form.resetFields()
    }
  }, [visible, data, form])

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields()
      setSubmitting(true)

      const formData = new FormData()
      formData.append("id", values.id)
      formData.append("paidAmount", values.paidAmount)
       formData.append("paymentDate", moment.utc(values.paymentDate).format("YYYY-MM-DD"))
      formData.append(
        "deadLineDate",
        moment.utc(values.deadLineDate).format("YYYY-MM-DD")
      )
      if (values.paymentMethod)
        formData.append("paymentMethod", values.paymentMethod)
      formData.append("status", values.status)
      formData.append("description", values.description || "")

      const fileObj = values.receipt?.[0]?.originFileObj
      formData.append("receipt", fileObj || "")

      const res = await Http.post_form_data(
        "api/accounting/UpdatePaidMultipleUvDtfToTheCompany",
        formData
      )

      if (res.success) {
        toastr.success("Güncelleme başarılı.")
        onUpdated?.()
      } else {
        toastr.error(res?.message || "Güncelleme başarısız.")
      }
    } catch (err) {
      // validation hatası vs.
    } finally {
      setSubmitting(false)
    }
  }


  return (
    <Modal
      open={visible}
      title="Ödeme Güncelle"
      onCancel={onClose}
      onOk={handleSubmit}
      confirmLoading={submitting}
      okText="Güncelle"
      cancelText="Vazgeç"
      destroyOnClose
    >
      <Form layout="vertical" form={form}>
        <Form.Item name="id" hidden>
          <Input />
        </Form.Item>

        <Form.Item
          label="Ödenecek Miktar"
          name="paidAmount"
          rules={[{ required: true, message: "Zorunlu" }]}
        >
          <InputNumber min={0.1} style={{ width: "100%" }} disabled={isReadonly}/>
        </Form.Item>

        <Form.Item
          name="paymentMethod"
          label="Ödeme Şekli"
          rules={[{ required: true, message: "Zorunlu" }]}
        >
          <Select>
            {paymentMethods.map(pm => (
              <Option key={pm.value} value={pm.value}>
                {pm.label}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Son Ödeme Tarihi"
          name="deadLineDate"
          rules={[{ required: true, message: "Zorunlu" }]}
        >
          <DatePicker style={{ width: "100%" }} format="DD.MM.YYYY" disabled={isReadonly} />
        </Form.Item>

        <Form.Item label="Ödeme Tarihi" name="paymentDate">
          <DatePicker style={{ width: "100%" }} format="DD.MM.YYYY" />
        </Form.Item>

        <Form.Item
          name="status"
          label="Ödeme Durumu"
          rules={[{ required: true, message: "Zorunlu" }]}
        >
          <Select disabled={isReadonly}>
            <Option value={10}>Paid</Option>
            <Option value={0}>Unpaid</Option>
            <Option value={20}>In Progress</Option>
          </Select>
        </Form.Item>

        <Form.Item name="description" label="Açıklama">
          <TextArea rows={3} />
        </Form.Item>

        <Form.Item
          label="Dekont"
          name="receipt"
          rules={[{ required: true, message: "Zorunlu" }]}
          valuePropName="fileList"
          getValueFromEvent={e => (Array.isArray(e) ? e : e && e.fileList)}
        >
          <Upload
            accept=".pdf .tiff .tif .jpg .jpeg .png .image .heic" 
            maxCount={1}
            beforeUpload={() => false}
            className="upload-list-inline"
          >
            <Button icon={<UploadOutlined />}>Dekont Yükle</Button>
          </Upload>
        </Form.Item>
      </Form>
    </Modal>
  )
}
